import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';
import { ModalService } from '../../shared/helper-components/modal/_services/modal.service';

import { CIAsset } from '../clearance-item.model';
import { IAssetProcessing } from "./asset-processing.interface";
import { AppService } from "../../app.service";
import { map } from 'rxjs/internal/operators/map';

@Injectable()
export class AssetDocumentProcessing implements IAssetProcessing {


    // private _source = new Subject<string>();
    private _downloadFinished = new Subject<any>();
    private _downloadStarted = new Subject<boolean>();

    // sourceChanged = this._source.asObservable();
    onDownloadStarted = this._downloadStarted.asObservable();
    onDownloadFinished = this._downloadFinished.asObservable();

    constructor(private _appService: AppService, private sanitizer: DomSanitizer) { }

    assetType(): string {
        return 'document';
    }

    downloadAsset(asset:CIAsset, projectId: string, ownerType: string, direct: boolean = false, tryViewInBrowser: boolean = false) {
        this._downloadStarted.next(true);
        if (tryViewInBrowser){
            this._appService.getSignedUrlInline(encodeURIComponent(asset.url), projectId, 'GET', 'document', ownerType, encodeURIComponent(asset.name))
            .subscribe(signedUrl => {
                console.log('ImageProcessing.downloadAsset >> signed Url:' + signedUrl.url);
                let downloadedAsset = Object.assign(new CIAsset(), asset);
                downloadedAsset.name = asset.name;
                downloadedAsset.fullUrl = signedUrl.url;
                
                this._downloadFinished.next({asset: downloadedAsset, direct: direct});
            });    
        }
        else{
            this._appService.getSignedUrl(encodeURIComponent(asset.url), projectId, 'GET', 'document', ownerType, encodeURIComponent(asset.name))
            .subscribe(signedUrl => {
                console.log('ImageProcessing.downloadAsset >> signed Url:' + signedUrl.url);
                let downloadedAsset = Object.assign(new CIAsset(), asset);
                downloadedAsset.name = asset.name;
                downloadedAsset.fullUrl = signedUrl.url;
                
                this._downloadFinished.next({asset: downloadedAsset, direct: direct});
            });
        }
    }

    processAsset(file: File, projectId: string, ownerType: string): Observable<CIAsset> {
        
        //get the signed url to upload to aws
        return this._appService.getSignedUrl(encodeURIComponent(file.name), projectId, 'PUT', 'document', ownerType,'').pipe(
            map(signedUrl => {

                console.log('DocumentProcessing.processAsset >> signed Url:' + signedUrl.url);

                let newAsset = new CIAsset();
                newAsset.name = file.name;
                newAsset.urlName = signedUrl.name;
                newAsset.id = signedUrl.name;
                newAsset.fileType = (file.type === "" ? "application/octet-stream" : file.type);

                // Store upload info on the asset for the uploader to use
                (newAsset as any)._uploadUrl = signedUrl.url.toString();
                (newAsset as any)._uploadMethod = 'PUT';
                (newAsset as any)._uploadFile = file;

                //notify the listeners that this asset has been added to the loader queue
                return newAsset;
            })
        );

    }
}
